import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
  ComponentFactoryResolver,
  ViewChild,
  ViewContainerRef
} from "@angular/core";
import { StringHelpers } from "@edl-development/edl-common";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NavigationItem } from "./navigation-item.model";
import { NavigationSection } from "./navigation-section.model";
@Component({
  selector: "edl-modal-details",
  templateUrl: "./edl-modal-details.component.html",
  styleUrls: ["./edl-modal-details.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class EdlModalDetails implements OnInit {
  @Input() title: string;
  @Input() isReadOnly: boolean;
  @Input() navigationSections: Array<NavigationSection>;
  @Input() startingNavigationItemId: string;

  StringHelpers = StringHelpers;
  selectedItem: NavigationItem;

  shouldReloadPage: boolean;
  busy: boolean;
  hightlightStatus: Array<boolean> = [];
  @ViewChild("userdetails", { read: ViewContainerRef, static: true }) _container;

  constructor(
    public activeModal: NgbActiveModal,
    private componentFactoryResolver: ComponentFactoryResolver
  ) {}

  ngOnInit() {
    this.shouldReloadPage = false;
    const navigationItem = this.navigationSections.reduce((flattenedItems, navigationSections) => {
      return flattenedItems.concat(navigationSections.navigationItems);
    }, []).find((navigationItem: NavigationItem) => navigationItem.id === this.startingNavigationItemId);
    this.loadComponent(navigationItem);
  }

  loadComponent(navigationItem: NavigationItem) {

    this.selectedItem = navigationItem;

    this.busy = true;
    try {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
        this.selectedItem.component
      );
      const viewContainerRef = this._container;
      viewContainerRef.clear();

      this.selectedItem.callBack(
        {
          data: this.selectedItem.data,
          container: viewContainerRef,
          factory: componentFactory,
          parent: this
        },
        this.selectedItem.args
      );
    } catch (e) {
      this.busy = false;
    }
  }

  onSubmissionComplete = (success: boolean, shouldClose: boolean) => {
    if (success) {
      this.shouldReloadPage = true;
    }

    if (shouldClose) {
      this.close();
    }
  }

  close = () => {
    this.activeModal.close(this.shouldReloadPage);
  }
}
